"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const store_1 = require("@ngrx/store");
const idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_ng_controls_1 = require("@synisys/idm-ng-controls");
const idm_page_service_client_js_1 = require("@synisys/idm-page-service-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
const Observable_1 = require("rxjs/Observable");
const multilingual_type_helper_1 = require("../../../../shared/multilingual-type-helper");
const path_processing_helper_1 = require("../../../../shared/path-processing-helper");
const common_helper_functions_1 = require("../../../shared/common-helper-functions");
const main_settings_1 = require("../../../shared/settings/main-settings");
const chart_sort_type_model_1 = require("../../categorical-chart/shared/chart-sort-type.model");
const color_palette_service_1 = require("../../shared/service/color-palette.service");
const combination_chart_model_1 = require("../model/combination-chart.model");
let CombinationChartBuilderComponent = class CombinationChartBuilderComponent extends main_settings_1.MainSettings {
    constructor(pathService, currentLanguageProvider, languageService, messageService, colorPaletteService, datasetService, pageNavigationService, activatedRoute, store, changeDetectorRef, communicationService) {
        super(communicationService);
        this.pathService = pathService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.languageService = languageService;
        this.messageService = messageService;
        this.colorPaletteService = colorPaletteService;
        this.datasetService = datasetService;
        this.pageNavigationService = pageNavigationService;
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.changeDetectorRef = changeDetectorRef;
        this.ChartSortType = chart_sort_type_model_1.ChartSortType;
        /**
         * Emitter for the pie chart model state.
         */
        this.stateChange = new core_1.EventEmitter();
        this.availableMeasures = [];
        this.availableCategories = [];
        this.pages = [];
        /**
         * All available, filtered categories.
         * @type {any[]}
         * @private
         */
        this.filteredCategories = [];
        /**
         * All available, filtered series.
         * @type {any[]}
         * @private
         */
        this.filteredSeries = [];
        /**
         * One element array that contains the selected series. This field is used for series chip group.
         * @type {Array}
         * @private
         */
        this.selectedSeries = [];
        /**
         * The selected measures array. This field is used for series chip group.
         * @type {Array}
         * @private
         */
        this.selectedColumnMeasures = [];
        /**
         * The selected measures array. This field is used for series chip group.
         * @type {Array}
         * @private
         */
        this.selectedLineMeasures = [];
        /**
         * One element array that contains the selected category. This field is used for category chip group.
         * @type {Array}
         * @private
         */
        this.selectedCategories = [];
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(currentLanguageProvider);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(messageService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(colorPaletteService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(datasetService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pageNavigationService);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(store);
        this.datasetId = null;
        this._combinationChartModelState = null;
        this.datasetDtoComboboxOptions = [];
        this.currentLanguage = null;
    }
    get state() {
        return this._combinationChartState;
    }
    /**
     * This property stores chart model state, which we use to initialize control in case of dynamic forms
     */
    set state(combinationChartState) {
        this.initDatasetsComboboxOptions();
        combinationChartState && combinationChartState["state"] === "" && combinationChartState["datasetId"] === "" && (combinationChartState = null);
        this._combinationChartState = combinationChartState;
        combinationChartState && (this.datasetId = (combinationChartState["datasetId"] !== "" ? combinationChartState["datasetId"] : null));
        combinationChartState && (this._combinationChartModelState = combinationChartState["state"]);
        combinationChartState && (this._reportTitle = (!(combinationChartState["title"]) ? null : multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(combinationChartState["title"])));
        combinationChartState && (this.isDataTableShowed = (!(combinationChartState["isDataTableShowed"]) ? null : combinationChartState["isDataTableShowed"]));
        if (this.combinationChartStateEmitted == null || this._combinationChartState !== this.combinationChartStateEmitted) {
            this.createChartModelAndOptions(this._combinationChartModelState);
            this.resetState();
        }
    }
    get selectedDatasetId() {
        return this._selectedDatasetId;
    }
    /**
     * Sets the id of selected dataSet and resets state.
     * @param {number} selectedDatasetId
     */
    set selectedDatasetId(selectedDatasetId) {
        if (selectedDatasetId > 0) {
            this._selectedDatasetId = selectedDatasetId;
            this.datasetId = selectedDatasetId;
            this.createChartModelAndOptions(this._combinationChartModelState);
            this.resetState();
            this.stateToOutputs();
        }
    }
    /**
     * @inheritDoc
     */
    ngOnInit() {
        this.resetState();
        this.resetReportTitleSubscription();
        this.resetIsDataTableShowedSubscription();
    }
    /**
     * @inheritDoc
     */
    ngOnDestroy() {
        this.clearState();
        this.clearReportTitleSubscription();
        this.clearIsDataTableShowedSubscription();
        this.clearModelChangeSubscription();
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    updateCategories(selectedCategories) {
        const pathId = selectedCategories.length === 0 ? null : selectedCategories[0];
        pathId && this.setTimelineData(pathId);
        this.combinationChartModel.category = pathId;
        this.selectedCategories = selectedCategories;
        this.filteredSeries = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, this.combinationChartModel.category);
    }
    updateSeries(selectedSeries) {
        this.combinationChartModel.series = (selectedSeries.length === 0) ? null : selectedSeries[0];
        this.selectedSeries = selectedSeries;
        let selectedSeriesId = this.combinationChartModel.series;
        selectedSeriesId !== null ? this.measureMaxCount = 1 : this.measureMaxCount = 15;
        this.filteredCategories = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, selectedSeriesId);
    }
    updateColumnMeasures(selectedMeasures) {
        this.combinationChartModel.columnMeasures = selectedMeasures;
        this.selectedColumnMeasures = selectedMeasures;
    }
    updateLineMeasures(selectedMeasures) {
        this.combinationChartModel.lineMeasures = selectedMeasures;
        this.selectedLineMeasures = selectedMeasures;
    }
    swapCategoriesAndSeries() {
        const series = this.combinationChartModel.series;
        series && this.setTimelineData(series);
        this.combinationChartModel.setSeries(this.combinationChartModel.category);
        this.combinationChartModel.setCategory(series);
        this.filteredSeries = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, this.combinationChartModel.category);
        this.filteredCategories = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, this.combinationChartModel.series);
        this.selectedSeries = [this.combinationChartModel.series];
        this.selectedCategories = [this.combinationChartModel.category];
        this.stateToOutputs();
    }
    setTimelineData(pathId) {
        const path = this.categoryPaths.get(pathId);
        if (path.categoryType === idm_dataset_service_client_js_1.CategoryType.DATE) {
            this.combinationChartModel.setChartSortType(chart_sort_type_model_1.ChartSortType.TIME);
            this.combinationChartModel.excludeUnspecified = true;
        }
        else {
            this.combinationChartModel.setChartSortType(chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING);
            this.combinationChartModel.excludeUnspecified = false;
        }
    }
    /**
     * @override
     * Create output objects form current state.
     */
    stateToOutputs() {
        let title = (!this.reportTitle ? null : multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.reportTitle));
        this.combinationChartStateEmitted = {
            state: this.combinationChartModel.toJsonString(),
            datasetId: this.datasetId,
            title: title,
            isDataTableShowed: this.isDataTableShowed
        };
        this.stateChange.emit(this.combinationChartStateEmitted);
        this.sendPreviewMessageToParent();
    }
    /**
     * Set all the internal state to its default.
     */
    clearState() {
        this.categoryPaths = new Map();
        this.measuresPaths = new Map();
        this.clearPathsSubscription();
        this.combinationChartStateEmitted = null;
        this.datasetDtoName = null;
        this.currentLanguage = null;
        this.languages = [];
    }
    /**
     * Re-sets and re-initializes state of the component. Might be called on component initialization or changes to any
     * of the inputs. Initially loads some paths's data from services.
     * @see PathService
     */
    resetState() {
        this.clearState();
        skynet_store_currencies_api_1.getDefaultCurrency(this.store)
            .takeUntil(this.destroy$)
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((currencyModel) => {
            this.defaultCurrencyId = currencyModel.id;
        });
        // Load all available languages in the system.
        this.languageService.getAvailableLanguages()
            .takeUntil(this.destroy$)
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((languages) => {
            this.languages = languages;
        });
        // Load the current system language.
        this.currentLanguageProvider.getCurrentLanguage()
            .takeUntil(this.destroy$)
            .catch((err) => {
            return Observable_1.Observable.fromPromise(common_helper_functions_1.defaultPromiseErrorHandler(err));
        })
            .subscribe((language) => {
            this.currentLanguage = language;
        });
        if (Number.isInteger(this.datasetId)) {
            Promise.all([path_processing_helper_1.loadPaths(this.datasetId, this.pathService), path_processing_helper_1.loadPathGroups(this.datasetId, this.pathService), path_processing_helper_1.loadDatasetById(this.datasetId, this.datasetService)])
                .then(([paths, pathGroups, datasetName]) => {
                let availableRowCategoryPaths = new Map();
                let availableColumnMeasurePaths = new Map();
                // Filter paths for rows.
                path_processing_helper_1.extractAvailablePaths(paths.categoryPaths, availableRowCategoryPaths);
                // Filter paths for columns.
                path_processing_helper_1.extractAvailablePaths(paths.measurePaths, availableColumnMeasurePaths);
                this.pathGroups = pathGroups;
                this.categoryPaths = availableRowCategoryPaths;
                this.measuresPaths = availableColumnMeasurePaths;
                // Create options from the inputs and subscribe to language chages to recreate appropriately.
                this.resetPathsSubscription(this.categoryPaths, this.measuresPaths, this.pathGroups);
                this.datasetDtoName = datasetName;
            })
                .catch((err) => {
                return common_helper_functions_1.defaultPromiseErrorHandler(err);
            })
                .catch(() => {
                this.clearState();
            });
        }
    }
    /**
     * Un-subscribe and unset the subscription to the changes of the paths.
     */
    clearPathsSubscription() {
        if (this.pathsSubscription) {
            this.pathsSubscription.unsubscribe();
        }
        this.pathsSubscription = null;
    }
    /**
     * Subscribe and set the subscription to the changes of the paths in relation to the current language.
     * @param {PathsMap} categoryPaths - Category paths used in rows.
     * @param {PathsMap} measuresPaths - Measure paths used in columns (if category then default name measure assumed).
     * @param {Array<PathGroupDto>} pathGroups - The grouping metadata for the combo-box options.
     * @see CurrentLanguageProvider
     * @see MessageService
     */
    resetPathsSubscription(categoryPaths, measuresPaths, pathGroups) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(categoryPaths);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(measuresPaths);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(pathGroups);
        this.clearPathsSubscription();
        this.pathsSubscription = Observable_1.Observable
            .zip(this.currentLanguageProvider.getCurrentLanguage(), this.messageService.getMessage("reporting.controls.chart-designer.text.ungrouped"), Observable_1.Observable.from(this.pageNavigationService.getNavigation()), this.activatedRoute.params)
            .subscribe(([language, message, pages, params]) => {
            // Translate all available item options.
            this.availableCategories = path_processing_helper_1.initGroupedComboOptions(categoryPaths, pathGroups, language, message);
            this.availableMeasures = path_processing_helper_1.initGroupedComboOptions(measuresPaths, pathGroups, language, message, undefined, this.defaultCurrencyId);
            let pageId = params["pageId"];
            this.pages = path_processing_helper_1.processPageItems(pageId, pages, language.getId());
            this.stateFromInputs();
        });
    }
    loadDatasets() {
        return this.datasetService.getDatasets();
    }
    /**
     * Parse inputs and recover internal view's state.
     */
    stateFromInputs() {
        if (this.combinationChartModel && this.combinationChartModel.category) {
            // Populate initially selected options for row categories.
            this.selectedCategories = [this.combinationChartModel.category];
        }
        else {
            // Set empty state.
            this.selectedCategories = [];
        }
        if (this.combinationChartModel && this.combinationChartModel.series) {
            // Populate initially selected options for row categories.
            this.selectedSeries = [this.combinationChartModel.series];
        }
        else {
            // Set empty state.
            this.selectedSeries = [];
        }
        if (this.combinationChartModel && this.combinationChartModel.columnMeasures) {
            // Populate initially selected options for column measures.
            this.selectedColumnMeasures = path_processing_helper_1.setCurrenciesOfMeasures(this.availableMeasures, this.combinationChartModel.columnMeasures);
        }
        else {
            // Set empty state.
            this.selectedColumnMeasures = [];
        }
        if (this.combinationChartModel && this.combinationChartModel.lineMeasures) {
            // Populate initially selected options for column measures.
            this.selectedLineMeasures = path_processing_helper_1.setCurrenciesOfMeasures(this.availableMeasures, this.combinationChartModel.lineMeasures);
        }
        else {
            // Set empty state.
            this.selectedLineMeasures = [];
        }
        let selectedSeriesId = this.combinationChartModel.series;
        // If series is selected, only one measure is allowed in report
        selectedSeriesId !== null ? this.measureMaxCount = 1 : this.measureMaxCount = 15;
        this.filteredCategories = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, selectedSeriesId);
        let selectedCategoryId = this.combinationChartModel.category;
        this.filteredSeries = path_processing_helper_1.filterGroupedDataBySelectedItemId(this.availableCategories, selectedCategoryId);
    }
    /**
     * Creates combo box options for dataSet combo box.
     */
    initDatasetsComboboxOptions() {
        this.loadDatasets()
            .then((datasetDtos) => {
            let options = [];
            datasetDtos.forEach((datasetDto) => {
                options.push(new idm_ng_controls_1.ComboboxOption(datasetDto.id, datasetDto.name));
            });
            this.datasetDtoComboboxOptions = options;
        })
            .catch((err) => {
            return common_helper_functions_1.defaultPromiseErrorHandler(err);
        });
    }
    /**
     * These method create and initialize chart model and properties
     * @param state
     */
    createChartModelAndOptions(state) {
        this.combinationChartModel = new combination_chart_model_1.CombinationChartModel();
        state && this.combinationChartModel.fromJson(state);
        this.resetModelChangeSubscription();
    }
    clearModelChangeSubscription() {
        if (this.modelChangeSubscription) {
            this.modelChangeSubscription.unsubscribe();
        }
        this.modelChangeSubscription = null;
    }
    resetModelChangeSubscription() {
        this.clearModelChangeSubscription();
        this.modelChangeSubscription = this.combinationChartModel.getChartModelSubject().subscribe(() => {
            this.stateToOutputs();
        });
    }
};
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], CombinationChartBuilderComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], CombinationChartBuilderComponent.prototype, "state", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], CombinationChartBuilderComponent.prototype, "stateChange", void 0);
CombinationChartBuilderComponent = __decorate([
    core_1.Component({
        
        selector: "combination-chart-builder",
        styles: [require('./combination-chart-builder.component.css')],
        template: require('./combination-chart-builder.component.html')
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        template: "<combination-chart-builder [id]='%{id}' [state]='%{state}' (stateChange)='%{stateChange}'></combination-chart-builder>",
    }),
    __param(10, core_1.Optional()),
    __metadata("design:paramtypes", [idm_dataset_service_client_js_1.PathService, idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_message_language_service_client_js_1.LanguageService, idm_message_language_service_client_js_1.MessageService,
        color_palette_service_1.ColorPaletteService, idm_dataset_service_client_js_1.DatasetService,
        idm_page_service_client_js_1.PageNavigationService, router_1.ActivatedRoute,
        store_1.Store, core_1.ChangeDetectorRef,
        idm_dynamic_controls_metadata_1.CommunicationService])
], CombinationChartBuilderComponent);
exports.CombinationChartBuilderComponent = CombinationChartBuilderComponent;
//# sourceMappingURL=combination-chart-builder.component.js.map